import { useMemo } from "react";

import { useCookieConsent } from "@shared/providers";
import { AdTrackingTag } from "@shared/types";

export function AdTrackingTags({
  trackingTags,
}: {
  trackingTags: AdTrackingTag[] | null;
}) {
  const cookiesAccepted = useCookieConsent();
  if (!trackingTags || !cookiesAccepted) {
    return null;
  }
  return (
    <>
      {trackingTags.map((trackingTag, index) => (
        <TrackingTag
          key={`${trackingTag.url}-${index}`}
          trackingTag={trackingTag}
        />
      ))}
    </>
  );
}

function TrackingTag({ trackingTag }: { trackingTag: AdTrackingTag }) {
  const url = useMemo(() => {
    return (
      trackingTag.substitutions?.reduce(
        (url, substitution) =>
          url.replace(
            substitution.match,
            substitution.replacement === "random"
              ? Math.random().toString(36).substring(2, 15)
              : "",
          ),
        trackingTag.url,
      ) ?? trackingTag.url
    );
    // We want to prevent re-recreating new urls when the trackingTag object reference changes.
    // This could bloat impression tracking. Using the url as the dependency is a safe way to prevent this.
    // Substitutions would not change independent of the url, so it's safe to ignore them.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackingTag.url]);
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={url}
      width={1}
      height={1}
      alt={trackingTag.kind}
      className="absolute left-[-9999px] top-[-9999px]"
    />
  );
}
